/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'
import styled from 'styled-components'

import {
  TextHeading,
  useModalContext,
  Space,
  Modal,
  Button,
  get,
} from '@ally/metronome-ui'
import { CallUsBlock, FlagVariation } from '@ally/ally-login'

interface ForgotUsernameProps {
  buttonText?: string
  withAllyTM?: string
  variation: FlagVariation
}
const headingRef = React.createRef<HTMLHeadingElement>()

const StyledButton = styled(Button)`
  font-size: ${get.fontSizes('sm')};
`

const Content: React.FC<ForgotUsernameProps> = ({ variation }) => {
  const headingText =
    'Call us if you forgot your Bank, Invest, or Home Loans username.'
  return (
    <>
      <Space mb={24}>
        <TextHeading tag="h1" size="lg" tabIndex={-1} ref={headingRef}>
          {headingText}
        </TextHeading>

        <CallUsBlock variation={variation} />
      </Space>
    </>
  )
}

const Trigger: React.FC<{
  buttonText: string
  withAllyTM?: string
}> = ({ buttonText, withAllyTM }) => {
  const { setOpen } = useModalContext()
  return (
    <StyledButton
      allytmln={withAllyTM}
      variant="link"
      text={buttonText}
      onClick={(): void => setOpen(true)}
      data-testid="forgot-username-modal-button"
    />
  )
}

export const ForgotUsernameModal: React.FC<ForgotUsernameProps> = ({
  buttonText = 'username',
  withAllyTM = 'forgotUsername',
  variation,
}) => {
  return (
    <Modal
      content={<Content variation={variation} />}
      trigger={<Trigger buttonText={buttonText} withAllyTM={withAllyTM} />}
      width="md"
    />
  )
}
